import { render, staticRenderFns } from "./hoxton.html?vue&type=template&id=21bf5b4d&"
import script from "./hoxton.js?vue&type=script&lang=js&"
export * from "./hoxton.js?vue&type=script&lang=js&"
import style0 from "./hoxton.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports